import ProtectRoute from "../routes/ProtectRoute";
import LoginPage from "../screens/auth/LoginPage";
import CustomerList from "../screens/customer/customer_list/CustomerList";
import Dashboard from "../screens/dashboard/Dashboard";
import LiveSaleSessionList from "../screens/livesale/live_sale_list/LiveSaleSessionList";
import AddToCart from "../screens/request_product/add_to_cart/AddToCart";
import ProductList from "../screens/request_product/product_list/ProductList";
import SaleOrderDetail from "../screens/sale_order/sale_order_detail/SaleOrderDetail";
import SaleOrderList from "../screens/sale_order/sale_order_list/SaleOrderList";
import CustomerDetail from "../screens/customer/customer_detail/CustomerDetail";
import ChangePassword from "../screens/change_password/ChangePassword";
import CreateLiveSale from "../screens/livesale/create_live_sale/CreateLiveSale";
import RequestProductList from "../screens/request_product/request_product_list/RequestProductList";
import RequestProductDetail from "../screens/request_product/request_product_detail/RequestProductDetail";
import Layout from "../screens/report/Layout";
import ProductandCategory from "../screens/report/productandcategory/ProductandCategory";
import TeamDetails from "../screens/report/salesteam/TeamDetails";

export const RouteConfig = [
  {
    path: "/",
    element: (
      <ProtectRoute>
        <Dashboard />
      </ProtectRoute>
    ),
    special_access: "user",
  },
  {
    path: "/login",
    element: (
      // <ProtectRoute>
      <LoginPage />
      // </ProtectRoute>
    ),
  },
  {
    path: "/sale_order",
    element: (
      <ProtectRoute>
        <SaleOrderList />
      </ProtectRoute>
    ),
  },
  {
    path: "/sale_order_detail/:saleOrderId",
    element: (
      <ProtectRoute>
        <SaleOrderDetail />
      </ProtectRoute>
    ),
    special_access: "user",
  },
  {
    path: "/livesale/sessionList",
    element: (
      <ProtectRoute>
        <LiveSaleSessionList />
      </ProtectRoute>
    ),
  },
  {
    path: "/create/livesale",
    element: (
      <ProtectRoute>
        <CreateLiveSale />
      </ProtectRoute>
    ),
  },
  {
    path: "/customer_list",
    element: (
      <ProtectRoute>
        <CustomerList />
      </ProtectRoute>
    ),
  },
  {
    path: "/product_list",
    element: (
      <ProtectRoute>
        <ProductList />
      </ProtectRoute>
    ),
  },
  {
    path: "/add_to_cart",
    element: (
      <ProtectRoute>
        <AddToCart />
      </ProtectRoute>
    ),
  },
  {
    path: "/customer_detail",
    element: (
      <ProtectRoute>
        <CustomerDetail />
      </ProtectRoute>
    ),
  },
  {
    path: "/change_password",
    element: (
      <ProtectRoute>
        <ChangePassword />
      </ProtectRoute>
    ),
  },
  {
    path: "/request_product_list",
    element: (
      <ProtectRoute>
        <RequestProductList />
      </ProtectRoute>
    ),
  },
  {
    path: "/request_product_detail/:id",
    element: (
      <ProtectRoute>
        <RequestProductDetail />
      </ProtectRoute>
    ),
  },
  {
    path: "/sale_report",
    element: (
      <ProtectRoute>
        <Layout />
      </ProtectRoute>
    ),
  },
  {
    path: "/product_report",
    element: (
      <ProtectRoute>
        <ProductandCategory />
      </ProtectRoute>
    ),
  },
  {
    path: "/saleteam_report",
    element: (
      <ProtectRoute>
        <TeamDetails />
      </ProtectRoute>
    ),
  },
];
